<template>
    <div class="details-info width-66 width-sm-100 mx-auto">
        <vs-card>
            <div class="flex justify-between items-center" slot="header">                
                <h4>{{roomsObj.name}}</h4>
                <h5 class="mr-1">&#163;  {{roomsObj.price}}/ {{getPriceType(roomsObj.price_type)}}</h5>
            </div>
            <!-- <div class="details-short-info my-2">
                <vs-row>
                    <vs-col class="my-1" vs-type="flex" vs-align="center" vs-w="6">
                        <feather-icon icon="MapPinIcon" />
                        <span>San Francisco United State</span>
                    </vs-col>
                    <vs-col class="my-1" vs-type="flex" vs-align="center" vs-w="6">
                        <feather-icon icon="MailIcon" />
                        <span>xyz@gmail.com</span>
                    </vs-col>
                    <vs-col class="my-1" vs-type="flex" vs-align="center" vs-w="6">
                        <feather-icon icon="GlobeIcon" />
                        <span>website.com</span>
                    </vs-col>
                    <vs-col class="my-1" vs-type="flex" vs-align="center" vs-w="6">
                        <feather-icon icon="PhoneIcon" />
                        <span>+0000000000</span>
                    </vs-col>
                </vs-row>
            </div> -->
            <div class="carousel-example">
                <swiper :options="swiperOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl">
                    <swiper-slide v-for="(roomimage, index) in roomsObj.asset_images" :key="index">
                        <img class="responsive" :src="roomimage.files_details.file_path" alt="banner">
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
            </div>
        </vs-card>
            <vs-card>
                    <div class="con-tab-ejemplo">
                        <vs-row>
                            <vs-col vs-lg="6" vs-xs="12" class="px-2">
                                <vs-card>
                                    <div slot="header">
                                        <strong>Suitable For: </strong>
                                    </div>
                                    <ul class="amenities-list">
                                        <li v-for="(suitable, index) in roomsObj.asset_tags" :key="index">
                                            {{suitable.tag_name}}
                                        </li>
                                    </ul>
                                </vs-card>
                            </vs-col>
                            <vs-col vs-lg="6" vs-xs="12" class="px-2">
                                <vs-card>
                                    <div slot="header">
                                        <strong>Inventory: </strong>
                                    </div>
                                    <ul class="amenities-list">
                                        <li v-for="(inventory, index) in roomsObj.inventory_array" :key="index">
                                            {{inventory.name}}
                                        </li>
                                    </ul>
                                </vs-card>
                            </vs-col>
                        </vs-row>
                    </div>
               
            </vs-card>
            <!-- <vs-col vs-lg="3" vs-xs="12">
                    <vs-card>
                        <div slot="header">
                            <h2>Need Our Help?</h2>
                        </div>
                        <div>
                            <b>24/7 Dedicated Customer Support</b>
                            <div class="flex items-center w-full my-4">
                                <feather-icon icon="PhoneIcon" />
                                <span>+0000000000</span>
                            </div>
                            <div class="flex items-center w-full my-4">
                                <feather-icon icon="MailIcon" />
                                <span>xyz@gmail.com</span>
                            </div>
                        </div>
                    </vs-card>
                </vs-col> -->
    </div>
</template>

<script>
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'Rooms Details',
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      swiperOption: {
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      roomsObj: {}
    }
  },
  created () {
    this.roomsObj = this.$route.params.roomDetail
  },
  methods:{
    getPriceType (type) {
      if (type === 1) {
        return 'Per Day'
      }  else if (type === 2) {
        return 'Per Hour'
      } else {
        return 'Per Month'
      }
    }
  }
}
</script>

<style>
    .details-info svg {
        color: rgba(var(--vs-primary), 1);
        width: 16px;
        margin-right: 5px;
    }
    .amenities-list li {
        width: 50%;
        display: inline-flex;
        flex-wrap: wrap;
        margin: 10px 0;
        padding-left: 10px;
        position: relative;
        font-weight: 500;
    }
    .amenities-list li:before {
        content: '\00B7';
        color: rgba(var(--vs-primary), 1);
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        font-size: 20px;
        font-weight: bold;
    }
    .swiper-slide img {
        width: auto;
        max-width: 100%;
        height: auto;
        max-height: 400px;
        object-fit: contain;
    }
</style>